/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of an account deletion task
 * @export
 */
export const AccountDeletionTaskStatus = {
    Scheduled: 'SCHEDULED',
    Started: 'STARTED',
    Email1Sent: 'EMAIL1_SENT',
    Email2Sent: 'EMAIL2_SENT',
    Email3Sent: 'EMAIL3_SENT',
    Canceled: 'CANCELED',
    Completed: 'COMPLETED'
} as const;
export type AccountDeletionTaskStatus = typeof AccountDeletionTaskStatus[keyof typeof AccountDeletionTaskStatus];


export function instanceOfAccountDeletionTaskStatus(value: any): boolean {
    for (const key in AccountDeletionTaskStatus) {
        if (Object.prototype.hasOwnProperty.call(AccountDeletionTaskStatus, key)) {
            // @ts-ignore
            if (AccountDeletionTaskStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AccountDeletionTaskStatusFromJSON(json: any): AccountDeletionTaskStatus {
    return AccountDeletionTaskStatusFromJSONTyped(json, false);
}

export function AccountDeletionTaskStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountDeletionTaskStatus {
    return json as AccountDeletionTaskStatus;
}

export function AccountDeletionTaskStatusToJSON(value?: AccountDeletionTaskStatus | null): any {
    return value as any;
}

